import { render, staticRenderFns } from "./LiveFB.vue?vue&type=template&id=38bed454"
import script from "./LiveFB.vue?vue&type=script&lang=js"
export * from "./LiveFB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports